export const API_URL = "https://live.healthassure.in/ProviderPortalApi/api/User";
// export const API_URL_CAMPAIN = "https://live.healthassure.in/ProviderPortalApi/api/User";
// export const API_URL_CAMPAIN = "https://live.healthassure.in/ProviderPortalApi/api/User";
// export const API_URL_CAMPAIN = "https://live.healthassure.in/ProviderPortalApi/api/User";
export const API_URL_WITHOUT_USER =
  "https://live.healthassure.in/ProviderPortalApi/api";
export const API_KEY =
  "joxNjM0MjE2NDQ5fQ.nk2tgCC1NRAbaperiPWQXXoNgybL27zdN3T4dC5L-ak";
export const API_URL_TELECONSULTATION =
  "https://live.healthassure.in/TeleApi/api";

  